module.exports = __webpack_public_path__ + "static/img/banner.5751046.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/medical/banner.jpg
// module id = 48Ib
// module chunks = 1